import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppletCatalogContainerModel } from "../../../../../models";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../shared';
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class AppletToCatalogLinkService extends BaseApiTemplateService<AppletCatalogContainerModel>{

    protected apiUrl: string;

    constructor(http: HttpClient) {
        super();
        this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'applet-to-catalog-link';
        this.httpClient = http;
    }

    sysadminPost(dtoObject: AppletCatalogContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
        }
        return this.httpClient.post<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            dtoObject,
            this.getHttpHeader(apiVisa)
        );
    }

    sysadminPut(dtoObject: AppletCatalogContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
        }
        return this.httpClient.put<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            dtoObject,
            this.getHttpHeader(apiVisa)
        );
    }

    sysadminDelete(linkGuid: string, apiVisa: ApiVisa) {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/' + linkGuid;
        }
        return this.httpClient.delete(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    sysadminGetAll(apiVisa: ApiVisa) {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
        }
        return this.httpClient.get(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    sysadminGetByGuid(linkGuid: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/' + linkGuid;
        }
        return this.httpClient.get<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<AppletCatalogContainerModel>> {
        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues();
        }
        return this.httpClient.get<PagingResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    getByCriteriaAsSysAdmin(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<AppletCatalogContainerModel>> {

        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues()
        }

        return this.httpClient.get<PagingResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    getByCriteriaAsTenantAdmin(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<AppletCatalogContainerModel>> {

        if (this.endpoint_path && apiVisa.api_domain_url) {
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + apiVisa.tenantCode + '/login-tenant-ep/query?' + pagination.getQueryKeyValues()
        }

        return this.httpClient.get<PagingResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    getByGuidAsTenantAdmin(guid: String, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + apiVisa.tenantCode + '/login-tenant-ep/' + guid;

        return this.httpClient.get<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            this.getHttpHeader(apiVisa)
        );
    }

    createAsTenantAdmin(dao: AppletCatalogContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + apiVisa.tenantCode + '/login-tenant-ep';

        return this.httpClient.post<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            dao,
            this.getHttpHeader(apiVisa)
        );
    }

    updateAsTenantAdmin(dao: AppletCatalogContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppletCatalogContainerModel>> {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + apiVisa.tenantCode + '/login-tenant-ep';

        return this.httpClient.put<BasicApiResponseModel<AppletCatalogContainerModel>>(
            this.apiUrl,
            dao,
            this.getHttpHeader(apiVisa)
        );
    }

    deleteAsTenantAdmin(guid: String, apiVisa: ApiVisa) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + apiVisa.tenantCode + '/login-tenant-ep/' + guid;

        return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
    }
}